import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/stock/error.tsx");
